module.exports = __webpack_public_path__ + "static/media/sg11sj.b8431b9d.png";